import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateComponent = () => {
  const token = localStorage.getItem("token");

  // strict validation
  if (!token || token === "null" || token === "undefined") {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="main-content">
      <Outlet />
    </div>
  );
};

export default PrivateComponent;